import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export function logStatusActivity(context, type, opts) {
  context.executeAction(SetAndLogActivity, {
    agentId: context.stores.agentStatus.get().id,
    type,
    ...opts,
  });
}
